const isDebugBuild = import.meta.env.VITE_HYPEDIRECTOR_DEBUG === 'true';

const nativeConsole = {
  debug: console.debug.bind(console),
  info: console.info.bind(console),
  warn: console.warn.bind(console),
  error: console.error.bind(console),
};

const runtimeDebugEnabled = (() => {
  if (typeof window === 'undefined') return false;
  return window.localStorage.getItem('hd_debug') === '1';
})();

const isDebugEnabled = isDebugBuild || runtimeDebugEnabled;

export const debugLog = (...args: unknown[]) => {
  if (isDebugEnabled) nativeConsole.debug(...args);
};

export const infoLog = (...args: unknown[]) => {
  if (isDebugEnabled) nativeConsole.info(...args);
};

export const warnLog = (...args: unknown[]) => {
  nativeConsole.warn(...args);
};

export const errorLog = (...args: unknown[]) => {
  nativeConsole.error(...args);
};

export const applyConsoleOverrides = (): void => {
  console.debug = (...args: unknown[]) => debugLog(...args);
  console.info = (...args: unknown[]) => infoLog(...args);
  console.warn = (...args: unknown[]) => warnLog(...args);
  console.error = (...args: unknown[]) => errorLog(...args);
};
